import React from "react";
import { Icon, IconProps } from "./Icon";

export const Search = (props: IconProps) => {
  return (
    <Icon
      classes={props.classes}
      height="24px"
      width="24px"
      viewBox="0 0 12 12"
      dataTestId="icon-search"
    >
      <path d="M11.86 10.23 8.62 6.99a4.63 4.63 0 1 0-6.34 1.64 4.55 4.55 0 0 0 2.36.64 4.65 4.65 0 0 0 2.33-.65l3.24 3.23a.46.46 0 0 0 .65 0l1-1a.48.48 0 0 0 0-.62Zm-5-3.32a3.28 3.28 0 0 1-2.31.93 3.22 3.22 0 1 1 2.35-.93Z" />
    </Icon>
  );
};
